import { useId } from 'react';
import { Footprints, LayoutTemplate, type LucideIcon } from 'lucide-react';
import { Card } from '@/components/play';
import { TEMPLATE_CATALOG } from '@/components/event-viewer/templates';

type StarterKitsSectionProps = {
  handleStarterKitSelect: (templateId: string) => void;
};

/** Lucide glyphs for the catalog's templates; a new template gets the generic template glyph until it has its own. */
const TEMPLATE_ICONS: Record<string, LucideIcon> = {
  'ultra-running': Footprints,
};

/** The catalog's templates as Play cards: pressing one fills the prompt above. */
export function StarterKitsSection({ handleStarterKitSelect }: StarterKitsSectionProps) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="space-y-4">
      <h2 id={headingId} className="text-xl font-semibold text-neutral-10">Start from a template</h2>
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TEMPLATE_CATALOG.map((template) => {
          const Icon = TEMPLATE_ICONS[template.id] ?? LayoutTemplate;
          return (
            <Card
              key={template.id}
              as="li"
              headingLevel={3}
              icon={<Icon />}
              title={template.name}
              description={template.description}
              action={{ label: `${template.name} template`, onClick: () => handleStarterKitSelect(template.id) }}
            />
          );
        })}
      </ul>
    </section>
  );
}
